import React, { useState } from 'react';
import { Button } from 'antd';
import { LoginIcon } from 'icons';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { setTicket } from 'modules/auth';
import { testTypes } from 'modules/blok-test/constants';
import { globalConst } from 'modules/global';

import { ApplicationModal, Modal } from 'components';

import ResultsModal from './results-modal';

interface IProps {
  ticketId?: number;
  onClose: () => void;
  open: boolean;
  testType: string;
  isExam?: boolean;
}

const testTypeStyles = {
  [testTypes.TOPIC_TEST]: {
    bg: 'bg-indigo-100',
    text: 'text-indigo-500',
    label: 'nav.mavzuli_test'
  },
  [testTypes.VIRTUAL_TEST]: {
    bg: 'bg-green-100',
    text: 'text-green-500',
    label: 'home.banner.Virtualtest'
  },
  [testTypes.DTM_TEST]: {
    bg: 'bg-yellow-100',
    text: 'text-yellow-500',
    label: 'home.banner.DTMtest'
  },
  [testTypes.UNIVERSITY_TEST]: {
    bg: 'bg-blue-100',
    text: 'text-blue-500',
    label: 'home.banner.XususiyOliygohlar'
  }
};

const WarningModal: React.FC<IProps> = ({ onClose, ticketId, open, testType, isExam }) => {
  const t = useTranslations();
  const { push } = useRouter();
  const dispatch = useAppDispatch();
  const [openResults, setOpenResults] = useState(false);
  const [openApplication, setOpenApplication] = useState(false);
  const isRouteLoading = useAppSelector(state => state.routeLoading.isRouteLoading);
  const currentStyle = testTypeStyles[testType];

  const onRegister = () => {
    dispatch(setTicket(ticketId));
    push(globalConst.pageNames.LOGIN);
  };

  return (
    <>
      <Modal
        footer={false}
        open={open}
        centered
        onClose={onClose}
        width="380px"
        closeIcon={false}
        styles={{
          content: { padding: '8px 10px 3px 10px', borderRadius: '12px' }
        }}
        maskClosable={false}
        keyboard={false}
        closable={false}
      >
        <div className="mb-5 flex flex-col items-center justify-center">
          <div className='relative w-32 h-32'>
            <Image src="/images/test-paper-3d.webp" fill alt="Test paper 3d" title="Test Paper 3d" />
          </div>
          {testType === testTypes.TOPIC_TEST}
          {currentStyle && (
            <div className={`my-3 rounded-md px-2 font-medium ${currentStyle.bg} ${currentStyle.text}`}>
              {t(currentStyle.label)}
            </div>
          )}{' '}
          <p className="mt-3 text-lg font-semibold">{t('ajoyib_natija')}</p>
          <p className="mt-2 px-5 text-center text-sm text-gray-400">
            {isExam
              ? t.rich('ajoyib_natija_tavsif_exam', {
                  i: chunks => <i className="text-indigo-500">{chunks}</i>
                })
              : t.rich('ajoyib_natija_tavsif', {
                  i: chunks => <i className="text-indigo-500">{chunks}</i>
                })}
          </p>
        </div>
        <div className="mt-10 flex items-center gap-2">
          {!isExam && testType === testTypes.TOPIC_TEST && (
            <Button
              onClick={() => setOpenResults(true)}
              className="!py-4.5 !w-full !rounded-md !border-transparent !bg-gray-100 !text-black hover:!bg-gray-200"
            >
              {t('natijani_korish')}
            </Button>
          )}
          {isExam ? (
            <Button
              onClick={() => setOpenApplication(true)}
              className="!py-4.5 !w-full !rounded-md !border-transparent !bg-green-500 !text-black !text-white hover:!bg-green-600"
            >
              <LoginIcon />
              {t('natijani_korish')}
            </Button>
          ) : (
            <Button
              loading={isRouteLoading}
              onClick={onRegister}
              className="!py-4.5 !w-full !rounded-md !border-transparent !bg-green-500 !text-black !text-white hover:!bg-green-600"
            >
              <LoginIcon />
              {t('auth.kirish')}
            </Button>
          )}
        </div>
      </Modal>
      <ApplicationModal ticketId={ticketId} open={openApplication} onClose={() => setOpenApplication(false)} />
      <ResultsModal ticketId={ticketId} onClose={() => setOpenResults(false)} open={openResults} />
    </>
  );
};

export default WarningModal;
